import type { TranslateService } from '@ngx-translate/core';
import { whispIndicatorLabels } from '../../../common/geo/whisp-indicator-labels';
import type { WhispFeatureFinding } from './whisp-feature-findings';
import { WHISP_RISK_RED } from './whisp-layer';

const MARK_STATUS_KEYS = { risk: 'whisp_status_RISK_tr', ok: 'whisp_status_OK_tr' } as const;
const MARK_COLORS = { risk: WHISP_RISK_RED, ok: '#2e7d32' } as const;

export function createWhispFeatureDetail(
  finding: WhispFeatureFinding,
  translate: Pick<TranslateService, 'instant'>
): HTMLElement {
  const detail = document.createElement('div');
  detail.dataset['testid'] = 'map-whisp-detail';
  detail.dataset['whisp'] = finding.mark;
  detail.style.cssText = `flex-shrink:0;margin:0 0 8px;padding:6px 8px;border-left:3px solid ${MARK_COLORS[finding.mark]};background:#fafafa;font-size:12px;`;
  detail.append(verdictLine(finding, translate));
  if (finding.groupIds.length)
    detail.append(textLine(`${translate.instant('whisp_group_tr')} ${finding.groupIds.join(', ')}`));
  const indicators = whispIndicatorLabels(finding.parts, translate);
  if (indicators.length) detail.append(indicatorList(indicators));
  return detail;
}

function verdictLine(finding: WhispFeatureFinding, translate: Pick<TranslateService, 'instant'>): HTMLElement {
  const verdict = textLine(translate.instant(MARK_STATUS_KEYS[finding.mark]));
  verdict.style.fontWeight = '600';
  verdict.style.color = MARK_COLORS[finding.mark];
  return verdict;
}

function textLine(text: string): HTMLElement {
  const line = document.createElement('div');
  line.textContent = text;
  return line;
}

function indicatorList(labels: string[]): HTMLElement {
  const list = document.createElement('ul');
  list.style.cssText = 'margin:4px 0 0;padding-left:16px;';
  for (const label of labels) {
    const item = document.createElement('li');
    item.textContent = label;
    list.append(item);
  }
  return list;
}
